
import { defineComponent } from 'vue'
import containerComponent from '@/components/container.components.vue'

import bannerModules from '@/modules/banner.modules.vue'
import filterDisplay from '@/modules/filter.modules.vue'
import cardsDisplay from '@/modules/cards_display.modules.vue'

export default defineComponent({
  name: 'HomeView',
  components: {
    containerComponent,
    bannerModules,
    filterDisplay,
    cardsDisplay
  },
  
})
